module.exports = __webpack_public_path__ + "static/media/WS.fa1b9cb2.svg";